import axios from "@/utils/request";

const state = {
  // 系统配置
  config: {},
};

const mutations = {
  // 设置语言
  SET_CONFIG(state, config) {
    state.config = config;
  },
};

const actions = {
  // 获取详情数据
  async fetchConfigs({ commit }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      try {
        const res = await axios.get("/api/configs/");
        commit("SET_CONFIG", res || {});
        resolve(res || {});
      } catch (error) {
        console.error(error);
        resolve({});
      }
    });
  },
}

const getters = {
  getIcp: (state) => state.config.icp,
  getIntroVideos: (state) => state.config.intro_videos && state.config.intro_videos.videos || [],
  getPlatformInfos: (state) => state.config.platform_infos && state.config.platform_infos.infos || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
